import Tool, { type ToolArgs } from '../../../tools/Tool';
import { ReactEditor } from 'slate-react';
import { Transforms } from 'slate';
import { type InfoBlockType } from '../../../types/aha-editor';
import BlockUtils from '../../Blocks/BlockUtils';

// Change an info block from one type to another.
class ToolInfoBlockType extends Tool {
  static blockType: InfoBlockType = 'infoBlock';

  static action({ editor, element }: ToolArgs): void {
    if (!element) return;

    const path = ReactEditor.findPath(editor, element);
    Transforms.setNodes(
      editor,
      { type: this.blockType },
      {
        at: path,
      }
    );
  }

  static isActive({ editor }: ToolArgs): boolean {
    if (!editor) return false;

    return BlockUtils.selectionIsBlockType(editor, this.blockType);
  }
}

class ToolInfoBlockTypeInfo extends ToolInfoBlockType {
  static blockType: InfoBlockType = 'infoBlock';
  static toolName = 'Info';
  static iconClass = 'fa-regular fa-info-circle';
}

class ToolInfoBlockTypeNote extends ToolInfoBlockType {
  static blockType: InfoBlockType = 'noteBlock';
  static toolName = 'Notice';
  static iconClass = 'fa-regular fa-pencil';
}

class ToolInfoBlockTypeWarning extends ToolInfoBlockType {
  static blockType: InfoBlockType = 'warningBlock';
  static toolName = 'Warning';
  static iconClass = 'fa-regular fa-exclamation-triangle';
}

class ToolInfoBlockTypeTip extends ToolInfoBlockType {
  static blockType: InfoBlockType = 'tipBlock';
  static toolName = 'Tip';
  static iconClass = 'fa-regular fa-magic-wand-sparkles';
}

export {
  ToolInfoBlockTypeInfo,
  ToolInfoBlockTypeNote,
  ToolInfoBlockTypeWarning,
  ToolInfoBlockTypeTip,
};
